import { render, staticRenderFns } from "./MultiFactorAuthForm.vue?vue&type=template&id=0bfc9ada"
import script from "./MultiFactorAuthForm.vue?vue&type=script&lang=ts"
export * from "./MultiFactorAuthForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports